(function ($) {

    // $('body').on('click', '.product-attribute, .close-button span', toggleClass);

    // function toggleClass() {
    //     $(this).toggleClass('product-attribute-on');
    // }
    
    $(document).ready(function () {
        $(".ecommerce-btn-dropdown").click(function () {
            $(this).toggleClass('active');
            $(this).siblings(".ecommerce-dropdown-content").toggleClass("show");
        });
        $(".ecommerce-dropdown-content a").click(function () {
            $(".ecommerce-dropdown-content a.active").removeClass("active");
            $(this).addClass("active");
        });

    });
}(window.jQuery));